import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📱 Native`}</h2>
    <ul>
      <li parentName="ul">{`We had a kick-off meeting for a new `}<inlineCode parentName="li">{`Avatar`}</inlineCode>{` component that will be built by Santi G. on iOS and Luke B. on Android.`}</li>
      <li parentName="ul">{`The Android Button component is nearing completion. (Mallika P.)`}</li>
      <li parentName="ul">{`Thumbprint Tokens was published to CocoaPods as a beta release (`}<inlineCode parentName="li">{`pod 'ThumbprintTokens', '8.1.0-beta.4'`}</inlineCode>{`). Daniel O. is working with Kevin B. to release this in Thumbprint and implement it in the iOS codebase.`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Native designs for Layouts, Messenger Elements, Cards, Carousels, Bottom Navigation, and Headers will be published Friday (Jon K.)`}</li>
      <li parentName="ul">{`Popover and the Date Picker for web have updated designs. (Jon K.)`}</li>
      <li parentName="ul">{`Avatar (update), Title Frame, and Global Shadows (beta) are in the works for both Native and web. (Jon K.)`}</li>
    </ul>
    <h2>{`🖥 Web`}</h2>
    <ul>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://thumbprint.design/components/avatar/react/"
        }}><inlineCode parentName="a">{`Avatar`}</inlineCode>{` React component`}</a>{` changes were released and rolled out in `}<inlineCode parentName="li">{`website`}</inlineCode>{`. The changes include new options, a rename of the default export, and a nicer design for avatars without images. (Giles L.)`}</li>
      <li parentName="ul">{`Images used in `}<inlineCode parentName="li">{`Avatar`}</inlineCode>{` are now lazy-loaded with `}<a parentName="li" {...{
          "href": "https://thumbprint.design/components/image/react/"
        }}>{`our Image component`}</a>{` rather than `}<a parentName="li" {...{
          "href": "https://github.com/aFarkas/lazysizes"
        }}>{`lazysizes`}</a>{`. (Daniel O.)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`eslint-plugin-react-hooks`}</inlineCode>{` is now configured correctly. (Giles L.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      